import { render, staticRenderFns } from "./comGradeAdd.vue?vue&type=template&id=4e77474d&scoped=true&"
import script from "./comGradeAdd.vue?vue&type=script&lang=js&"
export * from "./comGradeAdd.vue?vue&type=script&lang=js&"
import style0 from "./comGradeAdd.vue?vue&type=style&index=0&id=4e77474d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e77474d",
  null
  
)

export default component.exports